module.exports = __webpack_public_path__ + "img/first-race.37deefb0.png";